import React, { useState } from 'react';
import { useLocale } from '../../localization/LocaleContext';
import './FeatureComparison.css';

const featureRows = [
    { key: 'aiEstimates', category: false },
    { key: 'documents', category: false },
    { key: 'clients', category: false },
    { key: 'items', category: false },
    { key: 'expenses', category: false },
    { key: 'timeTrackings', category: false },
    { key: 'emailReminders', category: false },
    { key: 'reports', category: false },
    { key: 'exportCsv', category: false },
    { key: 'priorityAi', category: false },
    { key: 'detailedAnalytics', category: false },
    { key: 'whiteLabeling', category: false },
    { key: 'statusTracking', category: false },
    { key: 'clientActivity', category: false },
    { key: 'signatures', category: false },
    { key: 'customBranding', category: false },
    { key: 'onlinePayments', category: false },
];

export default function FeatureComparison() {
    const { t } = useLocale();
    const [expanded, setExpanded] = useState(false);
    const visibleRows = expanded ? featureRows : featureRows.slice(0, 6);

    return (
        <section className="sp-90">
            <div className="container">
                <h2 className="h-2 h-bold text-center mb-20">{t('comparison.heading')}</h2>
                <p className="text-center mb-30" style={{ color: '#6b7280' }}>{t('comparison.subheading')}</p>

                <div className="comparison-table-wrapper">
                    <table className="comparison-table">
                        <thead>
                            <tr>
                                <th className="comparison-feature-col">{t('comparison.featureLabel')}</th>
                                <th className="comparison-plan-col">{t('pricing.plans.free.name')}</th>
                                <th className="comparison-plan-col comparison-plan-popular">{t('pricing.plans.premium.name')}</th>
                                <th className="comparison-plan-col">{t('pricing.plans.ultimate.name')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {visibleRows.map((row) => (
                                <tr key={row.key}>
                                    <td className="comparison-feature-name">{t(`comparison.features.${row.key}.name`)}</td>
                                    <td className="comparison-cell">{t(`comparison.features.${row.key}.free`)}</td>
                                    <td className="comparison-cell comparison-cell-popular">{t(`comparison.features.${row.key}.premium`)}</td>
                                    <td className="comparison-cell">{t(`comparison.features.${row.key}.ultimate`)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {featureRows.length > 6 && (
                    <div className="comparison-toggle">
                        <button
                            className="comparison-toggle-btn"
                            onClick={() => setExpanded(!expanded)}
                        >
                            {expanded ? t('comparison.showLess') : t('comparison.showAll')}
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                style={{ transform: expanded ? 'rotate(180deg)' : 'none', transition: 'transform 0.3s' }}
                            >
                                <polyline points="6 9 12 15 18 9" />
                            </svg>
                        </button>
                    </div>
                )}
            </div>
        </section>
    );
}
